import React from 'react'
import PropTypes from 'prop-types'
import { startCase } from 'lodash'
import Moment from 'moment'

const SecondContent = (props) => {
  const productType = props.data.productType.name
  const country = props.data.country.name


  return (
    <table className="table table-hover table-light">
      <tbody>
        <tr key="productType">
          <td width="400">Type</td>
          <td>{productType}</td>
        </tr>
        <tr key="country">
          <td width="400">Country</td>
          <td>{country}</td>
        </tr>
        {Object.keys(props.data).map((product) => {
          const changeTitle = {
            productTags: 'Topic',
            priceFixed: 'Price (Fixed)',
          }
          const title = (product in changeTitle)
            ? changeTitle[product]
            : product

          if (typeof props.data[product] !== 'object') {
            if (product === 'tags' || product === 'status' || product === 'id' || product === 'logo' || product === 'legacy' ||
              product === 'slug' || product === 'isEligible' || product === 'isPublished' ||
              product === 'targetAgeFrom' || product === 'targetAgeTo' || product === 'description' || product === 'name' || product === 'viewers' ||
              product === 'priceFrom' || product === 'priceTo' || product === 'priceFixed') {
              return null
            }
            if (product === 'createdAt') {
              return (
                <tr key={product}>
                  <td width="400">{startCase(title)}</td>
                  <td> {Moment(`${props.data[product]}`).format('MMMM, DD YYYY')} </td>
                </tr>
              )
            }
            if (product === 'updatedAt') {
              return (
                <tr key={product}>
                  <td width="400">{startCase(title)}</td>
                  <td> {Moment(`${props.data[product]}`).format('MMMM, DD YYYY')} </td>
                </tr>
              )
            }
          }
          if (Array.isArray(props.data[product])) {
            // const arrayContent = props.data[product].map(productField => productField.name)
            // return (
            //   <tr key={product}>
            //     <td width="400">{startCase(title)}</td>
            //     <td>{arrayContent.join(', ')}</td>
            //   </tr>
            // )
            return null
          }
          if (product === 'profile' || product === 'productType'
              || product === 'legacy' || product === 'country' || product === 'productLanguage' ||
              product === 'service' || product === 'format' || product === 'standard') {
            return null
          }
          return (
            <tr key={product}>
              <td width="400">{startCase(title)}</td>
              <td>
                {props.data[product].name

                  ? props.data[product].name
                  : `${props.data[product].firstName} ${props.data[product].lastName}`}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

SecondContent.propTypes = {
  data: PropTypes.shape({
    priceFixed: PropTypes.number.isRequired,
    viewers: PropTypes.number.isRequired,
    country: PropTypes.shape({
      currencyCode: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    productType: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default SecondContent
